/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { Cause } from './platformapi.schemas';

import getCausesMutator from '../custom-axios-instance';

/**
 * Retrieves a list of causes
 * @summary Get Causes
 */
export const getCauses = (signal?: AbortSignal) => {
  return getCausesMutator<Cause[]>({
    url: `${import.meta.env['VITE_API_HOST']}/causes/causes`,
    method: 'GET',
    signal,
  });
};

export const getGetCausesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/causes/causes`] as const;
};

export const getGetCausesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCauses>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCauses>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCausesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCauses>>> = ({ signal }) =>
    getCauses(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCauses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCausesQueryResult = NonNullable<Awaited<ReturnType<typeof getCauses>>>;
export type GetCausesQueryError = void;

export function useGetCauses<TData = Awaited<ReturnType<typeof getCauses>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCauses>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCauses>>,
          TError,
          Awaited<ReturnType<typeof getCauses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCauses<TData = Awaited<ReturnType<typeof getCauses>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCauses>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCauses>>,
          TError,
          Awaited<ReturnType<typeof getCauses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCauses<TData = Awaited<ReturnType<typeof getCauses>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCauses>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Causes
 */

export function useGetCauses<TData = Awaited<ReturnType<typeof getCauses>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCauses>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCausesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
